import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';

import { ModifierTypes } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['../input/input.component.scss']
})
export class InputPasswordComponent implements OnInit {
  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() placeholder = '';

  @Input() layoutMod: ModifierTypes[] = [];

  @Input() showCondition = true;

  type = 'password';

  layoutModifier = '';

  control!: AbstractControl | null;

  constructor(
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.control = this.mainForm.get(this.controlName);
    this.layoutModifier = this.stylingService.concatLayoutModifiers('inputField', this.layoutMod);
  }

  togglePasswordVisibility(): void {
    this.type = (this.type === 'password') ? 'text' : 'password';
  }
}
